/**
 * Monthlees shared analytics helper.
 * Merges attribution + member state into every PostHog event.
 * Does NOT init PostHog — PixieHog app embed owns that.
 */
(function () {
  'use strict';

  var PRECISION_PRODUCT_ID = 9195256479994;
  var MEMBERSHIP_HANDLES = {
    'monthlees-member-access': true,
    'monthlees-membership': true,
  };
  var TRIAL_HANDLES = {
    'membership-basic-monthly-trial': true,
    'membership-basic-annual-trial': true,
    'membership-basic-monthly-invited': true,
    'membership-basic-annual-invited': true,
  };

  var pageMeta = (window.MonthleesPageMeta && typeof window.MonthleesPageMeta === 'object')
    ? window.MonthleesPageMeta
    : {};

  function readCustomer() {
    var c = window.MonthleesCustomer || {};
    var body = document.body;
    var isMember =
      c.isMember === true ||
      !!(body && body.getAttribute('data-monthlees-persistent-member') === 'true');
    var loggedIn =
      c.loggedIn === true ||
      !!(body && body.getAttribute('data-monthlees-customer-member') &&
        body.getAttribute('data-monthlees-customer-member') !== 'guest');
    var customerState = isMember ? 'member' : 'guest';
    return {
      id: c.id || null,
      isMember: isMember,
      loggedIn: !!c.loggedIn || !!c.id || !!loggedIn,
      customerState: customerState,
    };
  }

  function baseProps() {
    var cust = readCustomer();
    var props = {
      is_member: cust.isMember,
      customer_state: cust.customerState,
      logged_in: cust.loggedIn,
      template: pageMeta.template || '',
      page_type: pageMeta.page_type || '',
    };
    try {
      var campaignFn =
        window.MonthleesAttribution &&
        (window.MonthleesAttribution.campaignProperties || window.MonthleesAttribution.properties);
      if (typeof campaignFn === 'function') {
        var attr = campaignFn.call(window.MonthleesAttribution) || {};
        var key;
        for (key in attr) {
          if (Object.prototype.hasOwnProperty.call(attr, key)) {
            props[key] = attr[key];
          }
        }
      }
    } catch (e) {
      /* ignore */
    }
    return props;
  }

  function track(eventName, props) {
    if (!eventName) return;
    var payload = baseProps();
    var extra = props || {};
    var key;
    for (key in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, key)) {
        payload[key] = extra[key];
      }
    }
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(eventName, payload);
      }
    } catch (e) {
      /* never break the page */
    }
  }

  function centsToDollars(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return null;
    return Math.round(n) / 100;
  }

  /**
   * Backend purchase_type vocabulary (match exactly):
   * retail · member_priced · membership_signup · membership_trial · precision_stack · mixed
   */
  function purchaseIntentFromItem(item) {
    if (!item) return 'retail';
    var handle = String(item.handle || item.product_handle || '').toLowerCase();
    var productId = Number(item.product_id || item.productId || 0);
    if (TRIAL_HANDLES[handle]) return 'membership_trial';
    if (MEMBERSHIP_HANDLES[handle]) return 'membership_signup';
    if (productId === PRECISION_PRODUCT_ID) return 'precision_stack';
    if (handle.slice(-7) === '-member') return 'member_priced';
    return 'retail';
  }

  function purchaseIntentFromCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return 'retail';
    var hasSignup = false;
    var hasTrial = false;
    var hasPrecision = false;
    var hasMemberPriced = false;
    var hasRetail = false;
    var i;
    for (i = 0; i < cart.items.length; i += 1) {
      var intent = purchaseIntentFromItem(cart.items[i]);
      if (intent === 'membership_signup') hasSignup = true;
      else if (intent === 'membership_trial') hasTrial = true;
      else if (intent === 'precision_stack') hasPrecision = true;
      else if (intent === 'member_priced') hasMemberPriced = true;
      else hasRetail = true;
    }
    // Backend precedence: signup > trial > precision > all-member-priced > mixed > retail
    if (hasSignup) return 'membership_signup';
    if (hasTrial) return 'membership_trial';
    if (hasPrecision) return 'precision_stack';
    if (hasMemberPriced && !hasRetail) return 'member_priced';
    if (hasMemberPriced && hasRetail) return 'mixed';
    return 'retail';
  }

  function cartSummary(cart) {
    var items = (cart && cart.items) || [];
    var hasMembership = false;
    var hasPrecision = false;
    var i;
    for (i = 0; i < items.length; i += 1) {
      var intent = purchaseIntentFromItem(items[i]);
      if (intent === 'membership_signup' || intent === 'membership_trial') hasMembership = true;
      if (intent === 'precision_stack') hasPrecision = true;
    }
    return {
      cart_value: centsToDollars(cart && cart.total_price),
      item_count: (cart && cart.item_count) || items.length || 0,
      has_membership: hasMembership,
      has_precision: hasPrecision,
      purchase_intent: purchaseIntentFromCart(cart),
    };
  }

  function parseAddResponse(data) {
    // /cart/add.js may return a single item or { items: [...] }
    if (!data) return [];
    if (Array.isArray(data.items)) return data.items;
    if (data.product_id || data.variant_id || data.id) return [data];
    return [];
  }

  /* ---------- Auto instrumentation ---------- */

  var viewedCart = false;
  var viewedProduct = false;
  var viewedCollection = false;
  var shownMemberPrices = {};

  function instrumentProductView() {
    if (viewedProduct) return;
    var meta = pageMeta.product;
    if (!meta || !meta.id) return;
    viewedProduct = true;
    track('product_viewed', {
      product_id: meta.id,
      handle: meta.handle || '',
      title: meta.title || '',
      price: meta.price != null ? centsToDollars(meta.price) : null,
      member_price: meta.member_price != null ? centsToDollars(meta.member_price) : null,
      is_member_priced: !!meta.is_member_priced,
      collection: meta.collection || '',
    });
  }

  function instrumentCollectionView() {
    if (viewedCollection) return;
    var meta = pageMeta.collection;
    if (!meta || !meta.handle) return;
    viewedCollection = true;
    track('collection_viewed', {
      collection: meta.handle,
      product_count: meta.product_count != null ? meta.product_count : null,
    });
  }

  function instrumentVariantSelected() {
    document.addEventListener('change', function (event) {
      try {
        var t = event.target;
        if (!t) return;
        var form = t.closest && t.closest('form[action*="/cart/add"], [data-monthlees-product-form], .monthlees-pdp');
        if (!form && !(t.name === 'id' || t.getAttribute('name') === 'id' || t.matches('[name="id"]'))) {
          // Also catch radio/select named options that update variant
          if (!(t.matches && (t.matches('[data-monthlees-variant-input]') || t.matches('input[name^="options"]') || t.matches('select[name^="options"]')))) {
            return;
          }
        }
        var meta = pageMeta.product || {};
        var variantId = null;
        var idInput =
          (form && form.querySelector('[name="id"]')) ||
          document.querySelector('.monthlees-pdp [name="id"], form[action*="/cart/add"] [name="id"]');
        if (idInput && idInput.value) variantId = idInput.value;
        if (t.name === 'id' && t.value) variantId = t.value;
        if (!variantId && !meta.id) return;
        var price = meta.price != null ? centsToDollars(meta.price) : null;
        track('variant_selected', {
          product_id: meta.id || null,
          variant_id: variantId ? Number(variantId) : null,
          price: price,
        });
      } catch (e) {
        /* ignore */
      }
    });
  }

  function fireCartViewed(cart) {
    if (viewedCart) return;
    viewedCart = true;
    var summary = cartSummary(cart || {});
    track('cart_viewed', summary);
    // Allow re-fire after close? Spec: on cart page or drawer open — once per open is nicer.
    setTimeout(function () {
      viewedCart = false;
    }, 1500);
  }

  function instrumentCartViewed() {
    try {
      if ((window.location.pathname || '').indexOf('/cart') === 0) {
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (cart) {
            if (cart) fireCartViewed(cart);
          })
          .catch(function () {});
      }
    } catch (e) {
      /* ignore */
    }

    try {
      var root = document.documentElement;
      var obs = new MutationObserver(function () {
        if (!root.classList.contains('monthlees-cart-drawer-open')) return;
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (cart) {
            if (cart) fireCartViewed(cart);
          })
          .catch(function () {});
      });
      obs.observe(root, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {
      /* ignore */
    }
  }

  function instrumentCheckoutStarted() {
    document.addEventListener(
      'click',
      function (event) {
        try {
          var t = event.target;
          if (!t || !t.closest) return;
          var btn = t.closest(
            '[name="checkout"], [data-cart-drawer-checkout] button[type="submit"], form[action*="/checkout"] button, a[href="/checkout"], button[form*="checkout"]'
          );
          if (!btn) return;
          fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (cart) {
              var summary = cartSummary(cart || {});
              track('checkout_started', {
                cart_value: summary.cart_value,
                item_count: summary.item_count,
                purchase_intent: summary.purchase_intent,
              });
            })
            .catch(function () {
              track('checkout_started', { purchase_intent: 'retail' });
            });
        } catch (e) {
          /* ignore */
        }
      },
      true
    );
  }

  function instrumentAddToCartViaFetch() {
    if (window.__monthleesAnalyticsFetchWrapped) return;
    window.__monthleesAnalyticsFetchWrapped = true;
    var originalFetch = window.fetch;
    if (typeof originalFetch !== 'function') return;

    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : input && input.url ? String(input.url) : '';
      } catch (e) {
        url = '';
      }
      var isAdd = url.indexOf('/cart/add') !== -1;
      var req = originalFetch.apply(this, arguments);
      if (!isAdd) return req;

      return req.then(function (response) {
        try {
          if (response && response.ok) {
            response
              .clone()
              .json()
              .then(function (data) {
                var items = parseAddResponse(data);
                var i;
                for (i = 0; i < items.length; i += 1) {
                  var item = items[i];
                  var intent = purchaseIntentFromItem(item);
                  var handle = String(item.handle || '').toLowerCase();
                  var props = {
                    product_id: item.product_id || null,
                    variant_id: item.variant_id || item.id || null,
                    quantity: item.quantity || 1,
                    price: centsToDollars(item.final_price != null ? item.final_price : item.price),
                    purchase_intent: intent,
                    handle: handle,
                  };
                  track('add_to_cart', props);
                  if (intent === 'membership_signup' || intent === 'membership_trial') {
                    track('membership_add_to_cart', {
                      plan: handle,
                      price: props.price,
                      is_trial: intent === 'membership_trial',
                    });
                  }
                }
              })
              .catch(function () {});
          }
        } catch (e) {
          /* ignore */
        }
        return response;
      });
    };
  }

  function instrumentMemberPriceShown() {
    function scan() {
      try {
        var cust = readCustomer();
        if (cust.isMember) return;
        var nodes = document.querySelectorAll('[data-monthlees-member-price], [data-member-teaser="true"]');
        var i;
        for (i = 0; i < nodes.length; i += 1) {
          var el = nodes[i];
          var card = el.closest('[data-product-id], [data-monthlees-product-id], .monthlees-product-card');
          var productId =
            (card && (card.getAttribute('data-product-id') || card.getAttribute('data-monthlees-product-id'))) ||
            el.getAttribute('data-product-id') ||
            '';
          if (!productId || shownMemberPrices[productId]) continue;
          var retailEl =
            (card && card.querySelector('[data-monthlees-guest-price], .monthlees-product-card__guest-value, s')) ||
            null;
          var memberText = (el.textContent || '').replace(/[^\d.]/g, '');
          var retailText = retailEl ? (retailEl.textContent || '').replace(/[^\d.]/g, '') : '';
          var memberPrice = memberText ? Number(memberText) : null;
          var retailPrice = retailText ? Number(retailText) : null;
          if (!memberPrice || !isFinite(memberPrice)) continue;
          shownMemberPrices[productId] = true;
          var savings =
            retailPrice && isFinite(retailPrice) ? Math.round((retailPrice - memberPrice) * 100) / 100 : null;
          track('member_price_shown', {
            product_id: Number(productId) || productId,
            retail_price: retailPrice,
            member_price: memberPrice,
            savings: savings,
          });
        }
      } catch (e) {
        /* ignore */
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(scan, 600);
      });
    } else {
      setTimeout(scan, 600);
    }
    setTimeout(scan, 2000);
  }

  function instrumentMembershipOffer() {
    function scan() {
      try {
        var nodes = document.querySelectorAll(
          '[data-monthlees-cart-drawer-membership], [data-monthlees-cart-membership], [data-cart-membership], .monthlees-cart-membership-required, [data-precision-member-gate]'
        );
        if (!nodes.length) return;
        var seen = {};
        var i;
        for (i = 0; i < nodes.length; i += 1) {
          var el = nodes[i];
          if (el.getAttribute('data-ml-offer-tracked') === '1') continue;
          // Only track visible-ish nodes
          if (el.offsetParent === null && !el.closest('.is-open')) continue;
          var placement =
            el.getAttribute('data-placement') ||
            (el.hasAttribute('data-monthlees-cart-drawer-membership')
              ? 'cart_drawer'
              : el.hasAttribute('data-precision-member-gate')
                ? 'precision_gate'
                : 'cart');
          if (seen[placement]) continue;
          seen[placement] = true;
          el.setAttribute('data-ml-offer-tracked', '1');
          track('membership_offer_viewed', {
            placement: placement,
            plan: el.getAttribute('data-plan') || '',
          });
        }
      } catch (e) {
        /* ignore */
      }
    }
    setInterval(scan, 2500);
    setTimeout(scan, 800);
  }

  function instrumentAuth() {
    document.addEventListener(
      'click',
      function (event) {
        try {
          var t = event.target;
          if (!t || !t.closest) return;
          var a = t.closest('a[href*="/customer_authentication"], a[href*="/account/login"], a[href*="/account/register"], [data-cart-membership-signin], [data-mg-embed-login]');
          if (!a) return;
          var href = a.getAttribute('href') || '';
          var source = 'unknown';
          if (a.hasAttribute('data-mg-embed-login') || a.closest('[data-mg-embed]')) source = 'magnus';
          else if (a.hasAttribute('data-cart-membership-signin') || a.closest('[data-cart-membership]'))
            source = 'cart_membership';
          else if (a.closest('[data-precision-member-gate]')) source = 'precision_gate';
          else if (href.indexOf('register') !== -1) source = 'account_register';
          else source = 'account_login';
          track('signin_started', { source: source });
          // Link click only — real account creation is customers/create (backend).
          if (href.indexOf('/account/register') !== -1 || href.indexOf('create_customer') !== -1) {
            track('account_create_intent', { source: source });
          }
        } catch (e) {
          /* ignore */
        }
      },
      true
    );
  }

  function boot() {
    instrumentAddToCartViaFetch();
    instrumentProductView();
    instrumentCollectionView();
    instrumentVariantSelected();
    instrumentCartViewed();
    instrumentCheckoutStarted();
    instrumentMemberPriceShown();
    instrumentMembershipOffer();
    instrumentAuth();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.MonthleesAnalytics = {
    track: track,
    purchaseIntentFromItem: purchaseIntentFromItem,
    purchaseIntentFromCart: purchaseIntentFromCart,
    baseProps: baseProps,
  };
})();
